import { render, staticRenderFns } from "./activity-sidebar.vue?vue&type=template&id=41a3b632&scoped=true&"
import script from "./activity-sidebar.vue?vue&type=script&lang=js&"
export * from "./activity-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./activity-sidebar.vue?vue&type=style&index=0&id=41a3b632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a3b632",
  null
  
)

export default component.exports